import { render, staticRenderFns } from "./LostIndex.vue?vue&type=template&id=769a973f&scoped=true&"
import script from "./LostIndex.vue?vue&type=script&lang=js&"
export * from "./LostIndex.vue?vue&type=script&lang=js&"
import style0 from "./LostIndex.vue?vue&type=style&index=0&id=769a973f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769a973f",
  null
  
)

export default component.exports